'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _page = require('./page.vue');

var _page2 = _interopRequireDefault(_page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _page2.default;